import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import {
  PaginatedResponseList,
  PaginatedResponseObject,
  TechnicianScheduleDayDto,
  TechnicianScheduleResponse,
  UpdateShiftCommand,
  BatchUpdateCommand,
  ResourceAvailabilityResponse
} from "../types/schedule.type";

// Base path aligns with backend controller routes: /api/pps/technicians/{id}/schedule
export const GetTechnicianScheduleRange = (
  technicianId: number,
  params: { startDate: string; endDate: string; includeHolidays?: boolean }
) => ({
  name: `TechnicianScheduleRange_${technicianId}_${params.startDate}_${params.endDate}`,
  handle: (): Promise<TechnicianScheduleResponse> =>
    apiCall({
      url: `technicians/${technicianId}/schedule`,
      method: HttpMethod.GET,
      params: {
        startDate: params.startDate,
        endDate: params.endDate,
        includeHolidays: params.includeHolidays ?? true
      }
    })
});

// Bulk per-technician AM/PM availability for the visible roster + range (WOR-2187).
// POST that reads — cached via useGetData keyed on the name below.
export const GetTechnicianAvailability = (params: {
  technicianIds: number[];
  startDate: string;
  endDate: string;
}) => ({
  name: `TechnicianAvailability_${params.startDate}_${params.endDate}_${params.technicianIds
    .slice()
    .sort((a, b) => a - b)
    .join("-")}`,
  handle: (): Promise<ResourceAvailabilityResponse> =>
    apiCall({
      url: `technicians/schedule/availability`,
      method: HttpMethod.POST,
      body: {
        technicianIds: params.technicianIds,
        startDate: params.startDate,
        endDate: params.endDate
      }
    })
});

export const UpdateTechnicianSingleShift = (technicianId: number) => ({
  name: `UpdateTechnicianSingleShift_${technicianId}`,
  handle: (
    command: UpdateShiftCommand
  ): Promise<PaginatedResponseObject<TechnicianScheduleDayDto>> =>
    apiCall({
      url: `technicians/${technicianId}/schedule/shift`,
      method: HttpMethod.POST,
      body: command
    })
});

export const UpdateTechnicianScheduleBatch = (technicianId: number) => ({
  name: `UpdateTechnicianScheduleBatch_${technicianId}`,
  handle: (
    command: BatchUpdateCommand
  ): Promise<PaginatedResponseList<TechnicianScheduleDayDto>> =>
    apiCall({
      url: `technicians/${technicianId}/schedule/batch`,
      method: HttpMethod.POST,
      body: command
    })
});

export const DeleteTechnicianShiftOverride = (technicianId: number) => ({
  name: `DeleteTechnicianShiftOverride_${technicianId}`,
  handle: (
    date: string,
    shift: "AM" | "PM" | "OT"
  ): Promise<PaginatedResponseObject<TechnicianScheduleDayDto>> =>
    apiCall({
      url: `pps/technicians/${technicianId}/schedule/shift`,
      method: HttpMethod.DELETE,
      params: { date, shift }
    })
});
